import { RootState } from '../../main/store/main.store.ts';
import { LessonTaskStepWithLessonAndTask } from '../../main/types/asset/lesson.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectNextStep = createMemoizedSelector(
  (state: RootState) => state.lesson.currentLessonTaskStepKey,
  (currentLessonTaskStepKey): LessonTaskStepWithLessonAndTask | null => {
    if (!currentLessonTaskStepKey) return null;
    return getLessonsUtil().getNextStep(currentLessonTaskStepKey);
  }
);
